import { Component, Inject, Input, OnInit } from '@angular/core';
import { JobService } from 'src/app/core/services/job.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { JobBoardsSearchHistoryInfiniteScrollContainer } from './job-boards-search-history-infinite-scroll-container';

@Component({
  selector: 'app-job-boards-search-history',
  templateUrl: './job-boards-search-history.component.html',
  styleUrls: ['./job-boards-search-history.component.css']
})
export class JobBoardsSearchHistoryComponent implements OnInit {

  @Input() jobId: any;
  @Input() jobTitle: any;
  @Input() clientOrBuName: any;

  jobBoards: any[] = [];
  isPanelOpen: boolean[] = [true];
  searchHistoryContainer: JobBoardsSearchHistoryInfiniteScrollContainer = null;

  constructor(
    private jobService: JobService,
    private resumeService: ResumeService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.getAllJobBoards(() => {
      this.searchHistoryContainer = new JobBoardsSearchHistoryInfiniteScrollContainer(
        this.jobId,
        this.jobBoards,
        this.jobService,
        this.alertsAndNotificationsService
      );
    });
  }

  getAllJobBoards(successCallback) {
    this.resumeService.getAllSourceTypes((data) => {
      if (data.length > 0) {
        this.jobBoards = data;
        if (successCallback) {
          successCallback();
        }
      }
    }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }
}
